export const NOTIFICACIONES = {
  TU_ARSAT: 'tu_arsat',
  TU_EQUIPO: 'tu_equipo',
};

export const PREFERENCIA = {
  LICENCIAS: [
    {
      name: 'tu_arsat_licenses.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las acciones requeridas',
    },
    {
      name: 'tu_arsat_licenses.mails',
      label: 'Recibir mails de las actualizaciones de tus solicitudes activas',
    },
    {
      name: 'tu_arsat_licenses.resumen',
      label: 'Recibir un resumen por mail con todas las novedades del día',
    },
  ],
  VIATICOS: [
    {
      name: 'tu_arsat_viaticos.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las acciones requeridas',
    },
    {
      name: 'tu_arsat_viaticos.mails',
      label: 'Recibir mails de las actualizaciones de tus viajes activos',
    },
    {
      name: 'tu_arsat_viaticos.resumen',
      label: 'Recibir un resumen por mail con todas las novedades del día',
    },
  ],
  PRESENTISMO: [
    {
      name: 'tu_arsat_jornada.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las novedades de tus fichadas irregulares',
    },
    {
      name: 'tu_arsat_jornada.mails',
      label: 'Recibir mails de las actualizaciones de tus fichadas irregulares',
    },
  ],
  RECIBOS: [
    {
      name: 'tu_arsat_recibos.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de los nuevos recibos disponibles',
    },
    {
      name: 'tu_arsat_recibos.mails',
      label: 'Recibir mails de los nuevos recibos disponibles',
    },
    {
      name: 'tu_arsat_recibos.resumen',
      label: 'Recibir un resumen por mail con todas las novedades del día',
    },
  ],
};

export const PREFERENCIA_EQUIPO = {
  LICENCIAS: [
    {
      name: 'tu_equipo_licenses.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las acciones requeridas',
    },
    {
      name: 'tu_equipo_licenses.mails',
      label: 'Recibir mails de los avisos',
    },
    {
      name: 'tu_equipo_licenses.resumen',
      label: 'Recibir un resumen por mail con todas las novedades del día',
    },
  ],
  VIATICOS: [
    {
      name: 'tu_equipo_viaticos.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las acciones requeridas',
    },
    {
      name: 'tu_equipo_viaticos.mails',
      label: 'Recibir mails de los avisos',
    },
    {
      name: 'tu_equipo_viaticos.resumen',
      label: 'Recibir un resumen por mail con todas las novedades del día',
    },
  ],
  PRESENTISMO: [
    {
      name: 'tu_equipo_jornada.notificaciones',
      label:
        'Recibir notificaciones por medio del portal de las acciones requeridas',
    },
  ],
  COMPARTIDOS: [
    {
      name: 'tu_equipo_compartidos.notificaciones',
      label: 'Recibir notificaciones por medio del portal de las delegaciones',
    },
    {
      name: 'tu_equipo_compartidos.mails',
      label: 'Recibir mails de los avisos de accesos compartidos',
    },
  ],
};

export const DEFAULT_VALUES_PREFERENCIAS = {
  tu_arsat_licenses: { notificaciones: false, mails: false, resumen: false },
  tu_arsat_viaticos: { notificaciones: false, mails: false, resumen: false },
  tu_arsat_jornada: { notificaciones: false, mails: false, resumen: false },
  tu_arsat_recibos: { notificaciones: false, mails: false, resumen: false },
  tu_equipo_licenses: { notificaciones: false, mails: false, resumen: false },
  tu_equipo_viaticos: { notificaciones: false, mails: false, resumen: false },
  tu_equipo_jornada: { notificaciones: false, mails: false, resumen: false },
  tu_equipo_compartidos: {
    notificaciones: false,
    mails: false,
    resumen: false,
  },
};
